import React from 'react';
import Footer from '../components/Footer';

const Services = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left - Text */}
            <div className="opacity-0 animate-slide-in-left">
              <h1 className="text-5xl font-bold text-black mb-12">SERVICES</h1>
              <div className="space-y-6">
                <p className="text-xl text-gray-700 leading-relaxed">
                  We are dedicated to helping our clients make smart and profitable investments. We offer a comprehensive range of services.
                </p>
                <p className="text-xl text-gray-700 leading-relaxed">
                  We take the time to understand our clients investment objectives, risk tolerance, and financial situation, in order to develop customized investment strategies that deliver maximum returns.
                </p>
              </div>
            </div>

            {/* Right - Image */}
            <div className="relative opacity-0 animate-slide-in-right delay-200">
              <img
                src="https://res.cloudinary.com/ditcmszc1/image/upload/v1769763263/Screenshot_2026-01-03_at_2.35.29_PM_rustpw_remxzd.png"
                alt="Investment Services"
                className="w-full h-auto rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Services;

